export default __webpack_public_path__ + "5c86844d9d83dcb6e06c74e1d6237f7b.ogg";